import { all, put, select, takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';
import { stopSubmit } from 'redux-form';
import { CHECK_ANSWERS_MODAL, QUESTIONNAIRE_FEEDBACK_FORM, QUESTIONNAIRE_FORM } from '../constants';
import { closeModal, openModal } from 'components/TP-UI/TPModal/actions';
import { checkCompletedQuestionnaire, getShowRecheckModal } from '../selectors';
import {
  confirmQuestionnaireFail,
  saveQuestionnaireAnswersFail,
  saveQuestionnaireAnswersSuccess,
  setDraftQuestionnaireAnswersFail,
  setDraftQuestionnaireAnswersSuccess,
} from '../actions';

function* showFeedbackFormError(action) {
  const errorMessage = get(action, 'error.data.message');
  yield put(
    stopSubmit(QUESTIONNAIRE_FEEDBACK_FORM, {
      _error: errorMessage,
    }),
  );
}

function* showFormError(action) {
  const errorMessage = get(action, 'error.data.message');
  yield put(
    stopSubmit(QUESTIONNAIRE_FORM, {
      _error: errorMessage,
    }),
  );
}

function* openCheckAnswersModal(action) {
  const user = action.response.data?.user;
  const questionnaireProgress = user?.cySecQuizProgress;
  const showRecheckModal = yield select(getShowRecheckModal);
  const completed = yield select(checkCompletedQuestionnaire);
  const showCheckModal = showRecheckModal && !questionnaireProgress?.status && completed;

  if (showCheckModal) {
    yield put(openModal(CHECK_ANSWERS_MODAL));
  }
}

function* closeCheckAnswersModal() {
  yield put(closeModal(CHECK_ANSWERS_MODAL));
}

export default function* watchRequest() {
  yield all([takeEvery(confirmQuestionnaireFail, showFeedbackFormError)]);
  yield all([takeEvery(setDraftQuestionnaireAnswersFail, showFormError)]);
  yield all([takeEvery(saveQuestionnaireAnswersFail, showFormError)]);
  yield all([takeEvery(saveQuestionnaireAnswersSuccess, closeCheckAnswersModal)]);
  yield all([takeEvery(setDraftQuestionnaireAnswersSuccess, openCheckAnswersModal)]);
}
